module.exports = __webpack_public_path__ + "img/ic_phone.722e1822.svg";